export default {
  maxFetchSize: 5000,
  normalFetchSize: 10,
};
